import React from 'react';

import NotificationManager from '../components/finance/notification/manager';

class FinanceNotificationPage extends React.Component {

    render() {
        return (
            <NotificationManager />
        )
    }
}


export default FinanceNotificationPage;


// WEBPACK FOOTER //
// ./src/containers/finance-notifications-page.js